import React from "react"
import EventCard from "@/components/molecules/EventCard/event-card"
import FeatureImg from "@/assets/images/job-detail.jpg"
import { formatDate } from '@/utils/index'

type EventListProps = {
  data: any[]
}

const EventList: React.FC<EventListProps> = ({ data }) => {
  return (
    <div className="grid grid-cols-1 gap-6 gap-y-12 px-4 sm:grid-cols-2 sm:gap-4 md:grid-cols-3 lg:p-0">
      {data.map((event) => (
        <div key={event._id} className="bg-white dark:bg-gray-900">
          <EventCard
            id={event._id}
            imageSrc={(event.featureImg && event?.featureImg[0] as string) ?? FeatureImg}
            title={event.title}
            subtitle={event.subTitle}
            updatedAt={formatDate(event.updatedAt)}
          />
        </div>
      ))}
    </div>
  )
}

export default EventList
